<template>
  <v-card>
    <v-menu
      min-width="300px"
      absolute
      offset-y
      :close-on-content-click="!bypassClickCloseMenu"
      :position-x="xMenu"
      :position-y="yMenu"
      :transition="null"
      :value="showMenu"
      @input="handleInput"
    >
      <template v-if="showMenu">
        <v-list
          style="max-width: 305px"
          :style="{
            maxHeight:
              screenHeight < 450 ? '220px' : menuItem.title ? '533px' : '365px',
          }"
          dense
          class="custom-menu-items"
        >
          <v-list-item
            v-if="menuItem.title && selectedItems.length < 2"
            :disabled="
              menuItem.status !== 'CONVERTING' &&
              menuItem.status !== 'CONVERTED'
            "
            @click="handleEditVideo(menuItem), $emit('keepSearchOpen')"
          >
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.openConfigs')
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="menuItem.name && selectedItems.length < 2"
            @click="handleGoToFolder(menuItem), $emit('keepSearchOpen')"
          >
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.open')
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="selectedItems.length === 1"
            @click="handleLogs(menuItem)"
          >
            <v-list-item-title>{{
              $t('message.pages.historyModal.history')
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="menuItem.title && selectedItems.length < 2"
            :disabled="
              menuItem.status !== 'CONVERTING' &&
              menuItem.status !== 'CONVERTED'
            "
            @click="handleOpenNewTab(), $emit('keepSearchOpen')"
          >
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.openInNew')
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="menuItem.name && selectedItems.length < 2"
            @click="handleOpenNewTab(), $emit('keepSearchOpen')"
          >
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.openInNew')
            }}</v-list-item-title>
          </v-list-item>
          <v-divider class="my-1" v-if="selectedItems.length < 2" />
          <v-list-item
            v-if="menuItem.name && selectedItems.length < 2 && hasEditVideoPerm"
            @click="handleEditFolder(menuItem), $emit('keepSearchOpen')"
          >
            <v-list-item-title class="d-flex justify-space-between">
              <span>{{ $t('message.pages.videosDataTable.menu.rename') }}</span>
              <span class="keyBtn">R</span>
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="menuItem.title && selectedItems.length < 2"
            dense
            :disabled="disableVideoCopyLinks"
            @click="openCustomizeEmbed(menuItem, 1), $emit('keepSearchOpen')"
          >
            <v-list-item-title>
              <v-row no-gutters class="d-flex flex-row align-center">
                <span class="mr-1"
                  >{{ $t('message.pages.videosDataTable.menu.copyEmbed') }}
                </span>
              </v-row>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="
              menuItem.title &&
              selectedItems.length < 2 &&
              !isExternalSourceVideo
            "
            :disabled="disableVideoCopyLinks"
            @click="handleCopyHLSEmbed(menuItem), $emit('keepSearchOpen')"
          >
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.copyHLS')
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            class="drmItem"
            v-if="menuItem && selectedItems.length < 2 && hasEditVideoPerm"
            :disabled="drmGroupsLoading"
            @click="handleDrmMenu(menuItem), $emit('keepSearchOpen')"
          >
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.drmConfig')
            }}</v-list-item-title>
          </v-list-item>
          <v-divider
            class="my-1"
            v-if="
              selectedItems.length < 2 && menuItem.title && hasEditVideoPerm
            "
          />
          <v-list-item
            v-if="selectedItems.length < 2 && menuItem.video_external_id"
            @click="handleRenameVideo(menuItem), $emit('keepSearchOpen')"
          >
            <v-list-item-title class="d-flex justify-space-between">
              <span>{{ $t('message.pages.videosDataTable.menu.rename') }}</span>
              <span class="keyBtn">R</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="handleMoveFiles(), $emit('keepSearchOpen')"
            v-if="hasEditVideoPerm"
          >
            <v-list-item-title>
              <span v-if="selectedItems.length > 1">
                {{
                  $t('message.moveFiles', {
                    count: selectedItems.length,
                  })
                }}
              </span>
              <span v-else>
                {{ $t('message.move') }}
              </span>
            </v-list-item-title>
          </v-list-item>
          <template v-if="!isExternalSourceVideo && hasEditVideoPerm">
            <v-list-item
              v-if="menuItem.title && selectedItems.length < 2"
              :disabled="menuItem.status !== 'CONVERTED'"
              @click="handleDuplicateVideo(menuItem), $emit('keepSearchOpen')"
            >
              <v-list-item-title class="d-flex justify-space-between">
                <span>{{ $t('message.duplicate') }}</span>
                <!-- <span class="keyBtn">Crtl+D</span> -->
              </v-list-item-title>
            </v-list-item>
            <!-- disabled vide download when imported-->
            <template v-if="checkIfIsImport(menuItem)">
              <v-tooltip left :disabled="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    link
                    v-bind="attrs"
                    v-on="on"
                    style="opacity: 0.5"
                  >
                    <v-row class="align-center">
                      <v-col
                        :cols="selectedItems.length < 2 ? 8 : 10"
                        class="align-center d-flex flex-row"
                      >
                        <v-list-item-title class="d-flex justify-space-between">
                          <span>{{ $t('message.download') }}</span>
                          <!-- <span class="keyBtn">Crtl+E</span> -->
                        </v-list-item-title>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </template>
                <div style="width: 300px">
                  <span>{{ $t('message.disabledDownloadTooltip') }}</span>
                </div>
              </v-tooltip>
            </template>
            <v-list-item
              v-else-if="
                !checkIfIsImport(menuItem) &&
                menuItem.title &&
                selectedItems.length < 2 &&
                disableVideoCopyLinks &&
                hasEditVideoPerm
              "
              disabled
            >
              <v-list-item-title>{{
                $t('message.download')
              }}</v-list-item-title>
            </v-list-item>
            <MenuItemDownload
              v-else-if="
                menuItem.title &&
                selectedItems.length < 2 &&
                hasEditVideoPerm &&
                !checkIfIsImport(menuItem)
              "
              :value="showMenu"
              :video="menuItem"
              :has-recuo="false"
              :video-id="menuItem.id"
              :fetch-on-mount="false"
              @click.native="bypassClickCloseMenu = true"
              @fetched="bypassClickCloseMenu = false"
              @submit="
                $emit('setDownloadServer', $event.downloadServer)
                qualityToBeDownloaded = $event.qualityToBeDownloaded
                $nextTick(() => $refs.downloadForm.submit())
              "
            />
          </template>
          <!-- list AI -->
          <v-divider class="my-1" v-if="canSeePlanInfo" />
          <template v-if="canSeePlanInfo">
            <v-list-item link @click="handleOpenSubModal">
              <v-row class="align-center">
                <v-col
                  :cols="selectedItems.length < 2 ? 8 : 10"
                  class="align-center d-flex flex-row"
                >
                  <!-- subtitle -->

                  <v-list-item-title>
                    <span v-if="selectedItems.length > 1">
                      {{ $t('message.ai.subtitles.generateSubtitles') }}...
                    </span>
                    <span v-else>
                      {{ $t('message.ai.subtitles.generateSubtitle') }}...
                    </span>
                  </v-list-item-title>
                </v-col>
                <v-col
                  v-if="selectedItems.length < 2"
                  cols="3"
                  class="text-end pa-0 ml-3"
                >
                  <simple-svg :src="require('@/assets/IconAI.svg')" />
                </v-col>
              </v-row>
            </v-list-item>
            <!-- dubbing -->
            <template>
              <v-list-item link @click="handleOpenDubModal">
                <v-row class="align-center">
                  <v-col
                    :cols="selectedItems.length < 2 ? 8 : 10"
                    class="align-center d-flex flex-row"
                  >
                    <v-list-item-title>
                      <span v-if="selectedItems.length > 1">
                        {{ $t('message.ai.dubbings.generateDubbings') }}...
                      </span>
                      <span v-else>
                        {{ $t('message.ai.dubbings.generateDubbing') }}...
                      </span>
                    </v-list-item-title>
                  </v-col>
                  <v-col
                    v-if="selectedItems.length < 2"
                    cols="3"
                    class="text-end pa-0 ml-3"
                  >
                    <simple-svg :src="require('@/assets/IconAI.svg')" />
                  </v-col>
                </v-row>
              </v-list-item>
            </template>
          </template>
          <v-divider class="my-1" />
          <!-- list AI -->
          <v-list-item
            class="removeItemSection"
            v-if="hasEditVideoPerm"
            @click="
              handleCheckIfCanDeleteItem(menuItem)
                ? null
                : handleRemoveItem(menuItem)
            "
            v-ripple="{ class: 'error--text' }"
            :disabled="menuItem.status === 'BLOCKED'"
          >
            <v-list-item-title
              :class="
                handleCheckIfCanDeleteItem(menuItem)
                  ? 'grey--text'
                  : 'danger-remove'
              "
            >
              <span class="danger-remove" v-if="selectedItems.length > 1">
                {{
                  $t('message.pages.video.defaultVideos.removeItems', {
                    count: selectedItems.length,
                  })
                }}
              </span>
              <span class="danger-remove" v-else>
                {{ $t('message.remove') }}
              </span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="screenHeight < 450 && !finishedScrolling"
            class="fixed-arrow d-flex justify-center align-center"
          >
            <v-icon>mdi-chevron-down</v-icon>
          </v-list-item>
        </v-list>
        <form
          ref="downloadForm"
          method="post"
          :action="downloadUrl"
          style="display: none"
        >
          <input
            ref="downloadInput"
            name="Authorization"
            :value="authToken"
            type="hidden"
          />
        </form>
      </template>
    </v-menu>
    <v-dialog v-model="showMenuEmbed" width="600px">
      <embed-video
        v-if="mustShowEmbedModal"
        :openFromVideoList="true"
        :videoId="videoId"
        :showMenuEmbed="showMenuEmbed"
        :startTime="embedVideo.startTime"
        :timeVideo="timeVideo"
        :embedSelectedProp="embedSelected"
        :fromVideoListing="true"
        :defaultTab="defaultTab"
        :fetching="fetching"
        :video="video"
        :isExternalSourceVideo="isExternalSourceVideo"
        @start-time="embedVideo.startTime = $event"
        @showEmbed="(val) => (showMenuEmbed = val)"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import downloadUrlMixin from '@/utils/downloadUrl.mixin.js'
import MenuItemDownload from '@/components/MenuItemDownload.vue'
import embedOptionOrientations from '@/utils/embedOptionOrientations.js'
import Storage from '@/utils/Storage'
import i18n from '@/translations/lang'
import { mapMutations, mapGetters } from 'vuex'
import { embedOptions as platformsOfEmbed } from '@/utils/embedOptions.js'
import embedCode from '@/utils/embedCode.mixin.js'
import EmbedVideo from '@/components/EmbedVideo.vue'

export default {
  data: () => ({
    bypassClickCloseMenu: false,
    embedOptionOrientations,
    embedTrademark:
      Storage.getItem('embedType') ??
      i18n.t('message.pages.videoEditModal.embedConfiguration.default'),
    qualityToBeDownloaded: null,
    showMenuEmbed: null,
    mustShowEmbedModal: null,
    video: {},
    timeVideo: 0,
    finishedScrolling: false,
    fetching: false,
    defaultTab: 1,
    embedVideo: {
      width: 720,
      height: 360,
      startTimeCheckbox: false,
      startTime: '00:00',
    },
    embedCode: {
      useMenuItem: true,
    },
    menuPosition: {
      x: 1920,
      y: 72,
    },
    embedSelected: '',
    svgContent_vMenu: null,
  }),
  components: {
    EmbedVideo,
    MenuItemDownload,
  },
  mixins: [downloadUrlMixin, embedCode],
  props: {
    xMenu: {
      type: Number,
      required: true,
    },
    yMenu: {
      type: Number,
      required: true,
    },
    screenHeight: {
      type: Number,
      required: false,
    },
    showMenu: {
      required: true,
    },
    menuItem: {
      required: true,
    },
    selectedItems: {
      type: Array,
      required: true,
    },
    downloadServer: {
      required: true,
    },
    drmGroupsLoading: {
      type: Boolean,
      required: true,
    },
    drmGroups: {
      required: true,
    },
    isDrmActive: {
      type: Boolean,
      required: true,
    },
  },
  async created() {
    try {
      const svgUrl = require('@/assets/dubbing.svg')
      const response = await fetch(svgUrl)
      const svgText = await response.text()
      this.svgContent_vMenu = svgText
    } catch (error) {
      console.error('Error to loading svg:', error)
    }
  },
  computed: {
    ...mapGetters('user', ['canSeePlanInfo']),
    videoId() {
      return this.menuItem.id
    },
    hasSomeDisabledVideo() {
      if (
        this.selectedItems.length &&
        this.selectedItems.some((item) => item.status === 'BLOCKED')
      ) {
        return true
      }
      return false
    },
    aspectRatio() {
      const { width, height } = this.menuItem
      let ratio = height / width
      if (Number.isNaN(ratio)) {
        ratio = 9 / 16
      }
      return `${ratio * 100}%`
    },
    disableVideoCopyLinks() {
      return this.menuItem.status === 'DRAFT'
    },
    embedOptions() {
      const [general] = platformsOfEmbed.filter(
        ({ value }) => value === 'general'
      )
      const rest = platformsOfEmbed.filter(({ value }) => value !== 'general')
      const sorted = rest.sort((a, b) => a.value.localeCompare(b.value))
      return [general, ...sorted]
    },
    isExternalSourceVideo() {
      return this.menuItem
        ? this.menuItem.hasOwnProperty('video_source')
        : false
    },
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
    svgDataUrl_vMenu() {
      return `data:image/svg+xml;utf8,${encodeURIComponent(
        this.svgContent_vMenu
      )}`
    },
  },
  watch: {
    showMenu: function (val) {
      this.$root.$emit('changeEmbed')
      let embedStored = Storage.getItem('embedType')
        ? Storage.getItem('embedType')
        : 'general'

      if (Storage.getItem('embedType')) {
        let embedOptionTrademark = this.embedOptions.map((val) => val.value)
        this.embedTrademark =
          this.embedOptions[embedOptionTrademark.indexOf(embedStored)].text
      } else {
        this.embedTrademark = embedStored
      }
      if (val) {
        this.waitForMenuContent()
      } else {
        const el2 = document.querySelector('.menuable__content__active')
        if (el2) {
          el2.removeEventListener('scroll', this.handleScroll)
        }
      }
    },
    showMenuEmbed(val) {
      if (val === false) this.$root.$emit('VideoEmbedModalHasClosed')
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_ROUTED_VIDEO', 'UPDATE_GLOBAL_SNACKBAR']),
    checkIfIsImport(menuItem) {
      if (!menuItem.description) return
      const desc = menuItem.description
      let val = desc.includes('hotmart') || desc.includes('vimeo')
      return val
    },
    handleCheckIfCanDeleteItem(menuItem) {
      return menuItem.status === 'BLOCKED' || this.hasSomeDisabledVideo
    },
    handleInput(event) {
      if (!this.bypassClickCloseMenu) {
        this.$emit('setShowMenu', event)
      }
    },
    handleKeyDown(e) {
      if (!this.showMenu) return
      if (e.key === 'r' && !e.ctrlKey) {
        this.handleRenameVideo(this.menuItem)
        e.preventDefault()
      }
      // if (e.key === 'd' && e.ctrlKey) {
      //   this.handleDuplicateVideo(this.menuItem)
      //   e.preventDefault()
      // }
    },
    waitForMenuContent() {
      const checkInterval = setInterval(() => {
        const el2 = document.querySelector('.menuable__content__active')

        if (el2) {
          clearInterval(checkInterval)
          this.checkIfScrollIsAvailable(el2)
          el2.addEventListener('scroll', this.handleScroll)
        }
      }, 100)
    },
    handleScroll(event) {
      const el = event.target
      this.checkIfScrolledToEnd(el)
    },
    checkIfScrolledToEnd(el) {
      const scrollPosition = el.scrollTop + el.clientHeight
      const scrollHeight = el.scrollHeight
      if (scrollPosition >= scrollHeight - 10) {
        this.finishedScrolling = true
      } else {
        el
        this.finishedScrolling = false
      }
    },
    checkIfScrollIsAvailable(el) {
      if (el.scrollHeight > el.clientHeight) {
        this.finishedScrolling = false
      } else {
        this.finishedScrolling = true
      }
    },
    async openCustomizeEmbed(menuItem, defaultTab) {
      this.defaultTab = defaultTab
      this.menuPosition = {
        link: {
          x: window.innerWidth / 2 - 300,
          y: 140,
        },
        embed: {
          x: window.innerWidth / 2 - 300,
          y: 140,
        },
        dots: {
          x: 1500,
          y: 140,
        },
      }
      this.mustShowEmbedModal = null
      this.video = menuItem
      this.timeVideo = menuItem.length ?? 0
      this.fetching = true
      this.$emit('setShowMenu', false)
      this.showMenuEmbed = true
      setTimeout(
        function () {
          this.mustShowEmbedModal = true
        }.bind(this)
      )
      this.fetchEmbedVideo()
    },
    async fetchEmbedVideo() {
      this.fetching = true
      Storage.setItem('width', this.embedVideo.width)
      Storage.setItem('height', this.embedVideo.height)
      let storageEmbedOption = Storage.getItem('embedType')
      let embedOptionsValue = this.embedOptions.map((el) => el.value)
      let storageIndex = embedOptionsValue.indexOf(storageEmbedOption)
      if (storageIndex !== -1) {
        this.embedSelected = this.embedOptions[storageIndex].value
      } else {
        this.embedSelected = this.embedOptions[0].value
      }
      Storage.setItem('embedType', this.embedSelected)
      let pullzoneValue = Storage.getItem(
        `pullzone-${this.$store.state.user.userInfo.sub ?? this.getSubKey()}`
      )
      this.userPullzoneName = pullzoneValue
      this.authToken = Storage.getItem('accessToken')
      this.$root.$on(
        'changeEmbed',
        function () {
          this.embedSelected = Storage.getItem('embedType')
            ? Storage.getItem('embedType')
            : i18n.t('message.pages.videoEditModal.embedConfiguration.default')
        }.bind(this)
      )
      this.fetching = false
    },
    handleRemoveItem(item) {
      if (this.selectedItems.length) {
        this.$root.$emit('deleteVideoModal', [...this.selectedItems])
      } else {
        let videos = []
        videos.push(item)
        this.$root.$emit('deleteVideoModal', [...videos])
      }
      this.$root.$emit('isAnyOtherModal', true)
    },
    handleDuplicateVideo(item) {
      this.$root.$emit('duplicateVideo', item.id)
    },
    handleDrmMenu(item) {
      this.$root.$emit('drmModalDashboard', {
        item: item,
        groups: this.drmGroups,
      })
      this.$root.$emit('isAnyOtherModal', true)
    },
    handleMoveFiles() {
      this.$root.$emit('isAnyOtherModal', true)

      if (this.selectedItems.length) {
        this.$root.$emit('moveModal', this.selectedItems)
        return
      }
      let arr = []
      arr.push(this.menuItem)
      this.$root.$emit('moveModal', arr)
    },
    handleEmbedCopy() {
      if (this.isExternalSourceVideo) this.handleShowLink(this.embed)
      else if (this.isExternalIdEmbed)
        this.handleCopyExternalIdEmbed(this.menuItem)
      else if (this.srcEmbed) this.handleCopySrcEmbed(this.menuItem)
      else if (this.codeEmbed) this.handleCopyCodeEmbed(this.menuItem)
      else if (this.hlsEmbed) this.handleCopyHLSEmbed(this.menuItem)
      else this.handleShowLink(this.embed)
    },
    handleCopyHLSEmbed(video) {
      let hls = `https://b-${video.pullzone_name}.tv.pandavideo.com.br/${video.video_external_id}/playlist.m3u8`
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.embedHlsCopiedToClipboard'),
        type: 'success',
      })
      navigator.clipboard.writeText(`${hls}`)
    },
    handleCopyCodeEmbed(video) {
      const code = video.id
      const open = true
      const text = i18n.t('message.embedCodeCopiedToClipboard')
      this.UPDATE_GLOBAL_SNACKBAR({ open, text, type: 'success' })
      navigator.clipboard.writeText(`${code}`)
    },
    handleCopySrcEmbed(video) {
      const src = video.video_player
      const open = true
      const text = i18n.t('message.embedSrcCopiedToClipboard')

      this.UPDATE_GLOBAL_SNACKBAR({ open, text, type: 'success' })
      navigator.clipboard.writeText(`${src}`)
    },
    handleCopyExternalIdEmbed(video) {
      const src = video.video_external_id
      const open = true
      const text = i18n.t('message.embedSrcCopiedToClipboard')
      this.UPDATE_GLOBAL_SNACKBAR({ open, text, type: 'success' })
      navigator.clipboard.writeText(`${src}`)
    },
    handleShowLink(item) {
      let embedCode = item
      if (embedCode.includes('<script>if(!')) {
        embedCode = embedCode.split('<script>')
        embedCode[0].includes('<div style')
          ? (embedCode[0] += '</div>')
          : (embedCode[0] += '')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.copiedToClipboard'),
        type: 'success',
      })
      navigator.clipboard.writeText(`${embedCode[0]}`)
    },
    handleOpenNewTab() {
      let routeData = {}
      if (this.menuItem.title) {
        routeData = this.$router.resolve({
          name: 'VideoPage',
          params: { id: this.menuItem.id },
        })
      }
      if (this.menuItem.name) {
        routeData = this.$router.resolve({
          name: 'Folders',
          params: { id: this.menuItem.id },
        })
      }
      window.open(routeData.href, '_blank')
    },
    handleEditFolder(folder) {
      this.$root.$emit('folderModal', { ...folder, edit: true })
    },
    handleRenameVideo(video) {
      this.$root.$emit('videoModalRename', { ...video, edit: true })
    },
    handleEditVideo(video) {
      this.UPDATE_ROUTED_VIDEO({ ...video })
      this.$router.push({ name: 'VideoPage', params: { id: video.id } })
    },
    handleGoToFolder(item) {
      this.$router.push({ name: 'Folders', params: { id: item.id } })
    },
    handleLogs(item) {
      this.$root.$emit('openModalItemLogs', item)
    },
    setEmbed(option, videoItem) {
      const optionDefault = i18n
        .t('message.pages.videoEditModal.embedConfiguration.default')
        .toLowerCase()

      option = option.toLowerCase()
      const externalOption = this.isExternalSourceVideo ? option : false

      if (option === optionDefault) {
        option = this.embedSelected = 'general'
      }

      const [selectedOption] = this.embedOptions.filter(
        ({ value }) => value === option
      )

      if (externalOption) option = optionDefault

      const isExternalIdEmbed = ['123tapronto']
      const isSrcEmbed = [
        'cademi',
        'engaged',
        'ensinio',
        'monetizze',
        'blitzpay',
        'membertizze',
        'ticto',
      ]
      const isCodeEmbed = ['entrega-digital', 'creators-land']
      const isHLSEmbed = ['xgrow', 'greatpages', 'minervaead']
      const isRadioActiveFalse = Object.keys(this.embedOptionOrientations)
      const isRadioActiveTrue = this.embedOptions
        .map(({ value }) => {
          if (
            ![...isHLSEmbed, ...isRadioActiveFalse, 'general'].includes(value)
          )
            return value
        })
        .filter(Boolean)

      this.video = {}
      this.fetching = true
      this.$emit('setShowMenu', false)
      this.hlsEmbed = false
      this.codeEmbed = false
      this.srcEmbed = false
      this.embedSelected = option
      this.embedTrademark = selectedOption.text

      if (isExternalIdEmbed.includes(option)) {
        this.externalIdEmbed = true
        if (videoItem) this.handleCopyExternalIdEmbed(videoItem)
      } else if (isSrcEmbed.includes(option)) {
        this.srcEmbed = true
        if (videoItem) this.handleCopySrcEmbed(videoItem)
      } else if (isCodeEmbed.includes(option)) {
        this.codeEmbed = true
        if (videoItem) this.handleCopyCodeEmbed(videoItem)
      } else if (isHLSEmbed.includes(option)) {
        this.hlsEmbed = true
        this.radioActive = 1

        if (videoItem) this.handleCopyHLSEmbed(videoItem)
      } else {
        if (isRadioActiveTrue.includes(option)) {
          this.videoCustomSize = true
          this.radioActive = 1
        } else if (isRadioActiveFalse.includes(option)) {
          const orientation = this.isLandscapeOrientation
            ? 'landscape'
            : 'portrait'
          const { width, height } =
            this.embedOptionOrientations[option][orientation]

          this.videoCustomSize = false
          this.radioActive = 0

          this.embedVideo.width = width
          this.embedVideo.height = height
        }

        Storage.setItem('width', this.embedVideo.width)
        Storage.setItem('height', this.embedVideo.height)

        this.fetching = false
        this.video = videoItem

        if (this.embed) this.handleShowLink(this.embed)
      }

      if (externalOption) option = externalOption
      Storage.setItem('embedType', option)
    },
    async handleOpenDubModal() {
      if (!this.selectedItems.length) {
        this.selectedItems = [this.menuItem]
        await this.$nextTick()
      }
      this.$root.$emit('openBatchDubModal')
    },
    async handleOpenSubModal() {
      if (!this.selectedItems.length) {
        this.selectedItems = [this.menuItem]
        await this.$nextTick()
      }
      this.$root.$emit('openBatchSubModal')
    },
  },
  mounted() {
    this.authToken = Storage.getItem('accessToken')
    this.embedSelected = ''
    let storageEmbedOption = Storage.getItem('embedType') ?? 'general'
    if (!storageEmbedOption) Storage.setItem('embedType', 'general')
    this.embedSelected = storageEmbedOption.toLowerCase()
    this.setEmbed(
      Storage.getItem('embedType') ??
        i18n.t('message.pages.videoEditModal.embedConfiguration.default')
    )
    window.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown)
  },
}
</script>
<style lang="scss">
.circle-player {
  margin-right: 5px;
  margin-top: -2px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: rgb(30 216 231);
  display: inline-block;
}
.sectionStyle {
  background-color: #ebedff;
  color: var(--v-neutral-base);
  display: flex;
  border-radius: 24px;
  padding-left: 2px;
  padding-right: 2px;
  justify-content: center;
  font-size: small;
  font-weight: 500;
}
</style>

<style scoped lang="scss">
@media only screen and (min-width: 1440px) {
  ::v-deep .v-list-item.v-list-item--link.theme--light {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
}

.v-menu__content {
  border-radius: var(--spacing-01, 2px) !important;
  border: 1px solid varFigma(neutral-95-lightest) !important;
  background: varFigma(neutral-100-white) !important;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15) !important;
}

.fixed-arrow {
  border-top: 1px solid varFigma(neutral-95-lightest) !important;
  position: sticky;
  bottom: 0;
  background-color: varFigma(neutral-100-white) !important;
  z-index: 1;
}

.drmItem {
  border-top: 1px solid varFigma(neutral-95-lightest) !important;
}

.keyBtn {
  font-size: 12px;
  font-weight: 400;
  color: varFigma(neutral-60) !important;
}

.v-list-item__title {
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 150% !important; /* 18px */
  color: varFigma(neutral-30) !important;
}

.v-divider {
  background: varFigma(neutral-95-lightest) !important;
}
</style>
